import { MenuItem } from "./menu.model";

export const Admin: MenuItem[] = [
  {
    id: 1,
    label: "Dashboard",
    icon: "ri-dashboard-line",
    link: "/",
  },
  {
    id: 2,
    label: "Energy Dashboard",
    icon: "mdi mdi-video-input-component",
    link: "/energyDashboard",
  },
  {
    id: 3,
    label: "Configuration",
    icon: "ri-settings-5-line",
    link: "/customer",
    // subItems: [
    // {
    //   id: 3,
    //   label: "Customer",
    //   link: "/customer",
    //   parentId: 2,
    // },
    // {
    //   id: 4,
    //   label: "Machine",
    //   link: "/device",
    //   parentId: 2,
    // },
    // {
    //   id: 5,
    //   label: "Shift",
    //   link: "/shift",
    //   parentId: 2,
    // },
    // ],
  },
  {
    id: 4,
    label: 'Firmware',
    icon: "fab fa-slack",
    link: "/firmware"
  },
  {
    id: 5,
    label: 'Audit Logs',
    icon: "ri-contacts-book-2-fill",
    link: "/auditlogs"
  },
  {
    id: 6,
    label: 'Mapping',
    icon: "fas fa-microchip",
    link: "/superUser"
  }
];
